import { Week } from "@kanpla/types";

export const addWeek = (week: Week) =>
  week.map((day) => {
    const newDay = day;
    newDay.seconds += 604800;
    return newDay;
  }) as Week;
